<div *ngIf="name || filters?.length; else emptyPreview" class="surface-card border-1 border-round-xl border-blue-100 overflow-hidden shadow-1">
  <!-- Header -->
  <div class="p-4 bg-blue-50 border-bottom-1 border-blue-100 flex flex-row gap-3 align-items-center">
    <div class="bg-white border-round-xl flex align-items-center justify-content-center w-3rem h-3rem shadow-sm flex-shrink-0">
      <i class="pi pi-filter text-blue-700 text-lg"></i>
    </div>

    <div class="flex flex-column gap-1 min-w-0">
      <span class="font-medium text-500 text-xs uppercase tracking-wider">
        {{ 'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.TITLE' | translate }}
      </span>
      <span class="text-blue-900 font-bold text-xl text-overflow-ellipsis overflow-hidden white-space-nowrap">
        {{ name || ('DATA.MODULES.CAMPAINGS.SEGMENTS.MODAL.NAME_SEGMENT' | translate) }}
      </span>

      <div *ngIf="showStatusBadges" class="flex align-items-center gap-2 mt-1 flex-wrap">
        <span
          *ngIf="isDefault"
          class="text-xs px-2 py-1 border-round-md bg-orange-50 text-orange-700 border-1 border-orange-100 flex align-items-center gap-1"
        >
          <i class="pi pi-star-fill" style="font-size: 0.65rem"></i>
          {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_DEFAULT' | translate }}
        </span>
        <span
          *ngIf="isInUse"
          class="text-xs px-2 py-1 border-round-md bg-teal-50 text-teal-700 border-1 border-teal-100 flex align-items-center gap-1"
        >
          <i class="pi pi-check-circle" style="font-size: 0.65rem"></i>
          {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_IN_USE' | translate }}
        </span>
        <span
          *ngIf="filters?.length"
          class="text-xs px-2 py-1 border-round-md bg-bluegray-50 text-bluegray-600 border-1 border-bluegray-100 flex align-items-center gap-1"
        >
          <i class="pi pi-list" style="font-size: 0.65rem"></i>
          {{ filters.length }}
        </span>
      </div>
    </div>
  </div>

  <!-- Filters list -->
  <div class="p-4 bg-white">
    <div class="flex flex-column gap-3">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-list text-blue-400"></i>
        <span class="font-semibold text-900">
          {{ 'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.FILTERS_TITLE' | translate }}
        </span>
      </div>

      <div class="flex flex-column gap-2">
        <ng-container *ngIf="filters?.length; else noFilters">
          <div
            *ngFor="let filter of filters; let first = first"
            class="p-3 border-round-lg bg-bluegray-50 border-1 border-bluegray-100"
          >
            <div class="flex flex-row gap-2 align-items-start w-full">
              <div *ngIf="!first" class="mt-1 flex-shrink-0">
                <span class="text-xs font-semibold px-2 py-1 border-round bg-blue-500 text-white uppercase">
                  {{ 'DATA.MODULES.CAMPAINGS.SEGMENTS.MODAL.CONDITIONAL' | translate }}
                </span>
              </div>
              <div class="text-sm line-height-3 text-700 flex-grow-1">
                {{ getFilterText(filter) }}
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #noFilters>
          <p-messages severity="info" [closable]="false" styleClass="m-0">
            <ng-template pTemplate>
              <span class="text-sm">
                {{ 'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.NO_FILTERS' | translate }}
              </span>
            </ng-template>
          </p-messages>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyPreview>
  <div class="flex flex-column align-items-center justify-content-center py-6 text-400 opacity-60">
    <i class="pi pi-filter text-4xl mb-3"></i>
    <span class="text-sm text-center">
      {{ 'DATA.MODULES.CAMPAINGS.SEGMENTS.MODAL.START_FILLING' | translate }}
    </span>
  </div>
</ng-template>
